<script setup lang="ts">
import { computed } from 'vue'
import { Icon } from '@iconify/vue'

interface Props {
  data: object | string | number
  cellConfig: Object,
}

const props = defineProps<Props>()

</script>

<template>
  <div class="table-cell contract-step-cell">
    <template v-if="props.data == 'KHOI_TAO'"><span class="whitespace-nowrap">Khởi tạo</span></template>
    <template v-if="props.data == 'DA_KY'"><span class="whitespace-nowrap ">Đã ký</span></template>
    <template v-if="props.data == 'THUC_HIEN'"><span class="whitespace-nowrap text-[#f400ff]">Đang thực hiện</span></template>
    <template v-if="props.data == 'CHOT_DEAL'"><span class="whitespace-nowrap text-[#ff0000]">Chốt deal</span></template>
    <template v-if="props.data == 'QUYET_TOAN'"><span class="whitespace-nowrap text-[#ff0000]">Quyết toán</span></template>
    <template v-if="props.data == 'HOAN_TAT'"><span class="whitespace-nowrap text-[#58b500]">Hoàn tất</span></template>
  </div>
</template>

<style lang="scss">
.contract-step-cell{
  display: flex;
}
</style>
